    <nb-tabset (changeTab)="onChangeTab($event)">
      <nb-tab tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 80vh;">
        <p class="Titulo">Consulta - Grupo Tipo</p>
          <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;" (click)="consultarGrupoTipoConsulta()">
            <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
          </button>
        <app-spinner *ngIf="showSpinnerConsulta"></app-spinner>
        <div *ngIf="showGrupoTipoConsulta">
          <!-- <angular-slickgrid gridId="gridOptionsGrupoTipoConsulta"
              [columnDefinitions]="columnDefinitionsGrupoTipoConsulta"
              [gridOptions]="gridOptionsGrupoTipoConsulta" 
              [dataset]="datasetGrupoTipoConsulta" 
              gridHeight="380"
              gridWidth="100%"
              (onAngularGridCreated)="angularGridReadyGrupoTipoConsulta($event)">
           </angular-slickgrid> -->
            <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetGrupoTipoConsulta"
            [columnDefs]="columnDefinitionsGrupoTipoConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"
            />
        </div>
        <button nbButton size="tiny" style="float: right; margin-top: 50px;" class=" buttontz" [hidden]="!showGrupoTipoConsulta" [disabled]="!showGrupoTipoConsulta"
            (click)="exportToExcelGrupoTipo()" ><nb-icon icon="save-outline"></nb-icon>Exportar</button>
      </nb-tab>
      <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Alta" tabIcon="upload-outline" responsive style="height: 80vh;">
        <div class="row">
          <div class="col-4 float-left">
            <p class="Titulo">Alta Grupo Tipo</p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Descripción</mat-label>
                <input matInput #message1 maxlength="80" [(ngModel)]="descripcionGrupoTipo" name="descripcion">
                <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Descripción Breve</mat-label>
                <input matInput #message2 maxlength="40" [(ngModel)]="descripcionBreve" name="breve">
                <mat-hint align="end">{{message2.value.length}} / 40</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Código Externo</mat-label>
                <input matInput #message3 maxlength="40" [(ngModel)]="codigoExterno" name="codigo">
                <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
              <button *ngIf="!showSpinnerGuardar" nbButton size="tiny" status="primary" class="buttontz" (click)="altaGrupoTipo()">Guardar</button>
            </p>
          </div>
          <div>
            <button nbButton shape="round" size="small" class="buttontz float-right" (click)="consultarGrupoTipo()">
              <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
            </button>
          </div>
          <app-spinner class="col-6 float-right" *ngIf="showSpinner"></app-spinner>
          <div *ngIf="showGrilla" class="col-6 float-right">
            <!-- <angular-slickgrid gridId="gridGrupoTipo"
                [columnDefinitions]="columnDefinitionsGrupoTipo"
                [gridOptions]="gridOptionsGrupoTipo" 
                [dataset]="datasetGrupoTipo" 
                gridHeight="380"
                (onAngularGridCreated)="angularGridReadyGrupoTipo($event)">
             </angular-slickgrid> -->

          <ag-grid-angular
            #grilla2
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetGrupoTipoConsulta"
            [columnDefs]="columnDefinitionsGrupoTipoConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"
            />
          </div>
        </div>
      </nb-tab>
      <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Modificación" tabIcon="edit-outline" responsive style="height: 75vh;">
        <p class="Titulo">Modificar Grupo Tipo</p>
        <div class="row">
          <div class="col-4">
        <p-dropdown required class="limited-selector" id="inputClasificacion" placeholder="Seleccionar Grupo Tipo"
          [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="grupoTipo"
          [(ngModel)]="grupoTipoProcesado" (onChange)="obtenerDescripcionDropdown(grupoTipoProcesado)" [virtualScroll]="true"
          [itemSize]="31" [filter]="true"
          [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
        </p-dropdown>
          <p>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Descripcion</mat-label>
              <input matInput #message4 maxlength="80" [(ngModel)]="descripcionGrupoTipoEditar" name="descripcionGrupoTipoEditar">
              <mat-hint align="end">{{message4.value.length}} / 80</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Descripcion Breve</mat-label>
              <input matInput #message5 maxlength="40" [(ngModel)]="descripcionBreveEditar"
                name="descripcionBreveEditar">
              <mat-hint align="end">{{message5.value.length}} / 40</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Código Externo</mat-label>
              <input matInput #message6 maxlength="40" [(ngModel)]="codigoExternoEditar" name="codigoExternoEditar">
              <mat-hint align="end">{{message6.value.length}} / 40</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar</nb-checkbox>
          </p>
          <p>
            <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
            <button *ngIf="!showSpinnerModificar" nbButton size="tiny" status="primary" class=" btn-Modificar" (click)="modificarGrupoTipo()">Modificar</button>
          </p>
        </div>
        <div class="col-6 float-right">
          <app-spinner class="col-6 float-right" *ngIf="showSpinnerModificar"></app-spinner>
          <div *ngIf="showGrupoTipoModificar">
            <!-- <angular-slickgrid gridId="gridGrupoTipoModificar"
                [columnDefinitions]="columnDefinitionsGrupoTipoModificar"
                [gridOptions]="gridOptionsGrupoTipoModificar" 
                [dataset]="datasetGrupoTipoGrillaModificar" 
                gridHeight="380"
                (onAngularGridCreated)="angularGridReadyGrupoTipoModificar($event)">
             </angular-slickgrid> -->
           <ag-grid-angular
            #grilla3
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetGrupoTipoGrillaModificar"
            [columnDefs]="columnDefinitionsGrupoTipoModificar"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"
            />
          </div>
        </div>
      </div>
      </nb-tab>
    </nb-tabset>